<template>
  <div class="aboutUsPage">
    <!-- header start -->
    <van-nav-bar
      title="关于我们"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-collapse v-model="activeNames" :border="false">
        <van-collapse-item title="公司介绍" name="1" :border="false">
          <div class="mz_info">
            <!-- <p>&nbsp;&nbsp;&nbsp; 孝恩天堂是由深圳孝爱天下科技有限公司投资创办的具有自主知识产权的网上祭祀服务平台（国家版权局计算机软件著作权登记号2010SR040272）。</p>
            <p>&nbsp;&nbsp;&nbsp; 孝恩天堂除了为用户提供全面、专业的个性化、高仿真、交互性网上祭祀服务外，还提供了强大的氏族宗祠建设平台、讣告发布平台，并将开通在线族谱编撰管理系统，以及“遗嘱馆”即遗嘱在线保密箱服务等，全方位满足用户的多样化需求。</p>
            <p>
              <strong>孝恩天堂为用户提供了全面、专业的网上纪念服务，包括：</strong>
            </p>
            <p>1、提供功能全面强大的网上祭奠服务，拥有品种丰富的鲜花、供品、香烛等等，可以进行点歌、上香、点蜡、烧纸、上供、献花、祭酒和留言。</p>
            <p>2、提供多种风格的网墓，同时提供最具特色的“自定制网墓”功能，用户可自己制作喜欢的网墓。</p>
            <p>3、提供多款各具特色的个性化纪念馆模版，纪念馆不仅可保存逝者的文字资料，还能保存逝者的音像资料以及亲友的祭文。</p>
            <p>4、具有强大的管理功能，可以自行对纪念馆中的各种资料进行修改，比如生平、照片、留言等等。</p>
            <p>5、提供完全个性化的服务，自行上传背景、音乐、供品，自行定制网墓等等，实现最大的灵活性。</p>
            <p>6、提供天堂门户和天堂社区，为用户提供沟通交流的平台以及丰富的文化资讯。</p>
            <p>
              <strong>孝爱天下战略</strong>
            </p>
            <p>&nbsp;&nbsp;&nbsp; 致力于整合殡葬产业价值链，专注于网上殡葬市场，把网葬、网墓、网祭融于一体，线上平台与线下服务齐头并进，以上门服务为核心，不断提升天堂集团综合竞争能力，争取员工和股东利益最大化、公司价值最大化，最终实现上市目标。</p>
            <p>
              <strong>孝爱天下使命</strong>
            </p>
            <p>打造网葬服务商。</p>
            <p>①网葬：我们倡导绿色殡葬理念，倡导通过网络悼念逝者的精神和灵魂，让逝者的子孙将其精神代代相传，发扬光大。</p>
            <p>②我们的愿景是——让全世界的逝者在天堂找到归属，让每一个灵魂都成为永恒！</p>
            <p>③服务：我们的产品就是服务，客户是皇帝，皇帝一句话，太监跑断腿。我们将尽全力为客户提供贴心的服务，使客户满意。</p>
            <p>④商：我们将立足中国，辐射，用三至五年时间，将“天堂网”打造成网葬服务商、天堂福祉供应商、殡葬人才培训商和网络殡葬连锁加盟商。</p>
            <p>
              <strong>孝爱天下管理团队</strong>
            </p>
            <p>&nbsp;&nbsp;&nbsp; 孝爱天下公司遵循“人才创造价值”的理念，倡导“融智力，促天堂发展”，积极营造“大海纳百川，天堂聚贤才”的环境，注重人才梯队的建设，目前拥有一支专业高效、拼搏进取，勇于创新的管理团队。管理团队成员均在殡葬服务、殡葬文化及相关领域有多年的行业服务经验，对本行业有深入的了解，并具备敏锐的市场触觉和超前的创新思维。</p>
            <p>
              <strong>孝爱天下企业文化</strong>
            </p>
            <p>&nbsp;&nbsp;&nbsp; 以客户为中心，视客户为“皇帝”，“皇帝一句话，太监跑断腿”。以市场为导向，诚信务实，积极进取，励精图治，勇于创新，在相互尊重与认同的基础上达成高效团队合作，实现“男女抱团能生孩，员工抱团能生财”的理想。让员工个个都能成为精英，公司年年都能迈上新的发展台阶。</p>
            <p>
              <strong>孝爱天下主张</strong>
            </p>
            <p>抱团打天下，以人为本，打造十万创业富翁精英团队，实现个人价值、企业价值和社会价值的最大化。</p> -->
            <p>
              重庆孝恩天堂网络科技集团有限公司始创于2009年，公司主要致力于《孝恩天堂网》PC端、移动端APP、小程序等互联网平台、大数据领域的开发与应用等，
              以寻祖根、聚宗亲、传家风、兴家业来弘扬和传承中华优秀传统文化，利用“互联网+孝爱文化+新商业模式+新零售”来更好的弘扬传统美德，传承孝爱文化等。
            </p>
            <p>
              平台前期是以缅怀先祖作为切入点，为逝去的亲人提供网上公墓、网上祭祀祭拜、网上怀恋等服务。
            </p>
            <p>
              经过近10年的打造，《为行业领先的网上公墓、创新的人文孝爱服务平台，细分行业的高成长型企业。
            </p>
            <p>企业愿景：愿天下没有难敬的孝爱；</p>
            <p>
              企业目标：打造全球最大的网上公墓、世界最大的人文孝爱平台、做成国际一流的互联网中国企业；
            </p>
            <p>企业使命：弘扬传统美德，传承孝爱文化；</p>
            <p>
              学习对标：学习小米的商业模式，做成行业里的阿里巴巴，像爱奇艺、美团、携程等互联网企业一样驰名中外。
            </p>
          </div>
        </van-collapse-item>
        <van-collapse-item title="功能介绍" name="2" :border="false">
          <div>功能介绍</div>
        </van-collapse-item>
      </van-collapse>

      <div class="footer-agreement">
        <router-link to="/AgreementPage" class="footer__link"
          >用户协议</router-link
        >
        <router-link to="/PrivacyPage" class="footer__link"
          >隐私政策</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from "vant";
export default {
  data() {
    return {
      activeNames: ["1"],
    };
  },
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.aboutUsPage .mz_info p {
  margin-bottom: 20px;
  color: #333;
}
.aboutUsPage .van-collapse-item .van-cell {
  background-color: #eee;
}
.aboutUsPage .van-collapse-item__content {
  color: #555;
}
.footer-agreement {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 20px;
}
.footer__link {
  display: inline-block;
  vertical-align: top;
  margin: 0 0.62em;
  position: relative;
  font-size: 14px;
  color: #0277bd;
}
.footer__link:not(:first-child):before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  bottom: 0;
  border-left: 1px solid #0277bd;
  color: #0277bd;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleX(0.5);
  transform: scaleX(0.5);
  left: -0.65em;
  top: 0.36em;
  bottom: 0.36em;
}
</style>
